import { ReactNode } from 'react'

export type TabItem = {
  titleIcon?: ReactNode
  component?: ReactNode
  itemDisabled?: boolean
  disabledTooltip?: string
  indented?: boolean
  isLoading?: boolean
  badge?: number | string
  tabTitle?: ReactNode
  /** Keep content mounted when inactive (preserves state across tab switches). */
  forceMount?: boolean
} & (
  | {
      label: string
      index?: string // optional if label is string
    }
  | {
      label: Exclude<ReactNode, string>
      index: string // required if label is not string
    }
)

export type TabsProps<CustomTab = null> = {
  labelAsTitle?: boolean
  titleSuffix?: ReactNode
  items: Array<CustomTab extends null ? TabItem : CustomTab>
  actionItem?: ReactNode
} & React.HTMLAttributes<HTMLDivElement>

export const getTabItemIndex = (item: TabItem): string =>
  item.index || (typeof item.label === 'string' ? item.label : String(item.label))

export const isTabItem = (item: unknown): item is TabItem =>
  typeof item === 'object' && item !== null && 'label' in item && !('type' in item)

export const getDefaultTabIndex = (items: readonly unknown[]): string | undefined => {
  const defaultItem = items.filter(isTabItem).find(({ itemDisabled }) => !itemDisabled)
  return defaultItem ? getTabItemIndex(defaultItem) : undefined
}
